import React, { FC, ReactNode } from 'react';

export interface TypographyProps {
  variant?: 'medium' | 'regular';
  fontSize?: number | string;
  color?: string;
  letterSpacing?: number | string;
  display?: 'block' | 'inline' | 'inline-block';
  children: ReactNode;
  style?: React.CSSProperties;
  className?: string;
  onClick?: () => void;
}

const Typography: FC<TypographyProps> = ({
  variant = 'regular',
  fontSize = 16,
  color = '#000',
  letterSpacing = '0.02em',
  display = 'inline',
  children,
  style = {},
  className,
  onClick,
}) => {
  const fontFamily = variant === 'medium' ? 'Neue Montreal Medium' : 'Neue Montreal Regular';

  const baseStyle: React.CSSProperties = {
    fontFamily,
    fontSize,
    color,
    letterSpacing,
    display,
    margin: 0,
    padding: 0,
    ...style,
  };

  // Use div for block elements, span for inline elements
  const Component = display === 'block' ? 'div' : 'span';

  return (
    <Component
      className={className}
      style={baseStyle}
      onClick={onClick}
    >
      {children}
    </Component>
  );
};

export default Typography;
